import { yupResolver } from '@hookform/resolvers/yup'
import { integer, object } from '@if/core/yup'
import { ControlledNumberField } from '@if/mui'
import FormDialog from '@src/components/Common/Dialog/FormDialog'
import { useUnmountableDialog } from '@src/services/dialog'
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface MoveSelectedPaymentDialogProps {
  onConfirm: (nbOfDays: number) => void
  onClose: () => void
}

const MoveSelectedPaymentDialog = ({ onConfirm, onClose }: MoveSelectedPaymentDialogProps) => {
  const { t } = useTranslation()
  const resolver = useMemo(
    () =>
      yupResolver(
        object({
          nbOfDays: integer().required().notOneOf([0], t('loan.payment.moveCalendarDialog.errors.zeroDayShift')),
        }),
      ),
    [t],
  )

  const { control, handleSubmit } = useForm({ resolver })
  const { dialogProps, closeDialog } = useUnmountableDialog(onClose)
  const handleConfirm = handleSubmit((data) => {
    onConfirm(data.nbOfDays)
    closeDialog()
  })

  return (
    <FormDialog {...dialogProps} onConfirm={handleConfirm} title={t('loan.payment.moveCalendarDialog.title')}>
      <ControlledNumberField
        control={control}
        name="nbOfDays"
        label={t('loan.payment.moveSelectedPayments.nbOfDays')}
        disableDecimals
        enableNegative
        slotProps={{ input: { endAdornment: t('common.days') } }}
        autoFocus
      />
    </FormDialog>
  )
}

export default MoveSelectedPaymentDialog
